import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo.webp'
import _imports_1 from '@/assets/imgs/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-28816fbc")

_pushScopeId("data-v-28816fbc")
const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "pc-header-root" }
const _hoisted_3 = {
  key: 0,
  class: "logo"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("picture", { class: "logo_wrap" }, [
  /*#__PURE__*/_createVNode("source", {
    type: "image/webp",
    srcset: _hoisted_1
  }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    "data-was-processed": "true",
    "data-src": "~@/assets/imgs/logo.png"
  })
], -1)
const _hoisted_5 = {
  key: 1,
  class: "left-label"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon icon-heart" }, null, -1)
const _hoisted_7 = { class: "label" }
const _hoisted_8 = {
  key: 3,
  class: "empty"
}
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon icon-menu" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "icon icon-arrow-up" }, null, -1)
const _hoisted_12 = { class: "label" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "icon icon-arrow-down" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "label other" }, null, -1)
const _hoisted_15 = { class: "label" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "icon icon-user" }, null, -1)
const _hoisted_17 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")
  const _component_good_road_btn_svg = _resolveComponent("good-road-btn-svg")

  return (_openBlock(), _createBlock("header", _hoisted_2, [
    (_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.iN('common.livegames')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "btn-360",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLink && _ctx.openLink(...args)))
        }, "环球360旗舰"))
      : _createCommentVNode("", true),
    (_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", _hoisted_8))
      : _createCommentVNode("", true),
    (!_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", {
          key: 4,
          class: "switch-table-toggle",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSwitchTable && _ctx.showSwitchTable(...args)))
        }, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.title), 1),
          _hoisted_10
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", {
          key: 5,
          class: "limit-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-show-limit')))
        }, [
          _hoisted_11,
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.min) + "-" + _toDisplayString(_ctx.max), 1),
          _hoisted_13,
          _hoisted_14
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["other-label", { loby: !_ctx.isOnLoby }]
    }, [
      _createVNode(_component_app_svg, {
        box: '0 0 18.067 18.066',
        id: 'coin',
        className: 'coin-svg',
        fill: 'rgb(221, 194, 140)',
        stroke: 'rgb(221, 194, 140)'
      }, null, 8, ["box", "fill", "stroke"]),
      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.betCoin), 1)
    ], 2),
    _createVNode("div", {
      class: ["other-label", { loby: !_ctx.isOnLoby }]
    }, [
      _hoisted_16,
      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.userId), 1)
    ], 2),
    (!_ctx.isOnLoby)
      ? (_openBlock(), _createBlock("div", {
          key: 6,
          class: "single-show-btn",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showSingleShow && _ctx.showSingleShow(...args)))
        }, [
          _createVNode(_component_good_road_btn_svg, {
            count: _ctx.goodRoadCount,
            class: "good-road-btn-svg"
          }, null, 8, ["count"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["other-label", { loby: !_ctx.isOnLoby }]
    }, [
      _createVNode("span", {
        class: "icon icon-setting",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('on-show-setting')))
      })
    ], 2)
  ]))
})